import type { PromptDocument, UiPreference } from '@prompt-optimize/core'
import Dexie, { type EntityTable } from 'dexie'

export const DB_NAME = 'prompt-optimize'
export const DB_SCHEMA_VERSION = 1

/**
 * Row shape for the single-row `preferences` table. We key on a constant
 * id to avoid Dexie complaining about auto-inc primary keys.
 */
export interface PreferenceRow extends UiPreference {
  id: 'singleton'
  updatedAt: number
}

export class PromptDatabase extends Dexie {
  documents!: EntityTable<PromptDocument, 'id'>
  preferences!: EntityTable<PreferenceRow, 'id'>

  constructor() {
    super(DB_NAME)

    this.version(DB_SCHEMA_VERSION).stores({
      documents: 'id, updatedAt, name, starred',
      preferences: 'id',
    })
  }
}

let dbSingleton: PromptDatabase | null = null

export function getDb(): PromptDatabase {
  if (!dbSingleton)
    dbSingleton = new PromptDatabase()
  return dbSingleton
}

/**
 * Mostly for tests — let callers swap or close the singleton.
 */
export async function resetDb(): Promise<void> {
  if (dbSingleton) {
    dbSingleton.close()
    dbSingleton = null
  }
}
